import * as React from 'react';

type ChildProps = {
  isActive: boolean;
  name: string;
  type: string;
  showChart: (type: string) => void;
};

const divStyle = {
  marginBottom: '20px',
  paddingLeft: '15px',
  paddingRight: '15px',
  lineHeight: '2em',
  fontSize: '15px',
};

export const TempChartBtn: React.FC<ChildProps> = ({ isActive, name, showChart, type }): React.ReactElement => {
  return (
    <div className="col-md-6 col-4 control-button-container text-center" style={divStyle}>
      <span
        className={
          isActive
            ? 'active btn btn-lg btn-block btn-outline-primary col-md-12'
            : 'btn btn-lg btn-block btn-outline-primary col-md-12'
        }
        onClick={() => {
          showChart(type);
        }}
      >
        {name}
      </span>
    </div>
  );
};
